// @todo address and standardise

export const CARD_FLIP_TIME = 4000
export const cardFlipTimerExampleModal = 4000
export const LOCAL_STORAGE_KEY_NAME_DAILY = '26-pairs-game-stats-daily'
export const LOCAL_STORAGE_KEY_NAME_CLASSIC = '26-pairs-game-stats-classic'
export const LOCAL_STORAGE_KEY_NAME_LITE = '26-pairs-game-stats-lite'

// game difficulty strings

export const DAILY_SHUFFLE = 'DAILY_SHUFFLE'
export const CLASSIC_SHUFFLE = 'CLASSIC_SHUFFLE'
export const LITE_SHUFFLE = 'LITE_SHUFFLE'